import { useEffect, useMemo, useState } from 'react'
import { unixTimestampToHHMMSS, getDateDifference } from '../utils'

type UseCountdown = (opts: {
  timestamp: number
  onComplete?: () => void
}) => ReturnType<typeof getDateDifference> & {
  remainingFormatted: any
}

export const useCountdown: UseCountdown = ({ timestamp, onComplete }) => {
  const [remaining, setRemaining] = useState(timestamp - Date.now())

  const hasCompleted = useMemo(() => {
    const remainingTime = timestamp - Date.now()
    return remainingTime <= 0
  }, [timestamp])

  useEffect(() => {
    if (hasCompleted) {
      if (onComplete) onComplete()
      return
    }

    const timer: NodeJS.Timeout = setInterval(() => {
      const remainingTime = timestamp - Date.now()

      if (remainingTime <= 0) {
        if (onComplete) onComplete()
        return clearInterval(timer)
      }

      setRemaining(remainingTime)
    }, 1000)

    return () => clearInterval(timer)
  }, [hasCompleted, timestamp])

  return {
    ...getDateDifference(new Date(timestamp), new Date()),
    remainingFormatted: unixTimestampToHHMMSS(!hasCompleted ? remaining : 0)
  }
}
